exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loader-position{position:absolute;top:50%;z-index:99999}[dir=ltr] .loader-position{left:50%;transform:translate(-50%, -50%);-webkit-transform:translate(-50%, -50%)}[dir=rtl] .loader-position{right:50%;transform:translate(50%, -50%);-webkit-transform:translate(50%, -50%)}", ""]);

